import { registerSW } from "virtual:pwa-register";

import { claimReload, SW_RELOAD_STORAGE_KEY } from "./deployRecovery";
import { publishPwaUpdate } from "./pwaUpdate";

/**
 * Prompt mode: the new worker waits, so the open page keeps its cached chunks.
 * Accepting the prompt sends SKIP_WAITING; `clientsClaim` then fires `controlling`
 * and vite-plugin-pwa calls `onNeedReload`. The guard stops a second reload if
 * that event fires again on the next load (Safari has done this).
 */
export function registerPwa(target: Window = window): void {
  const updateServiceWorker = registerSW({
    onNeedRefresh() {
      publishPwaUpdate(() => updateServiceWorker(true));
    },
    onNeedReload() {
      if (
        claimReload(target.sessionStorage, SW_RELOAD_STORAGE_KEY, Date.now())
      ) {
        target.location.reload();
      }
    },
  });
}
